import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import th from './locales/th.json'

// 2 ภาษา: ไทย (ค่าตั้งต้น) · อังกฤษ สำหรับพนักงานต่างชาติ (22 ต.ค. 2569)
//   เดิม 13 ต.ค. 69 ล็อกเป็นไทยล้วน — ผู้ใช้สั่งเปิด EN/TH แล้ว
//   ค่าที่เลือกเก็บใน localStorage "pawin_lang" · เปลี่ยนผ่าน slices/languageSlice.js (setLanguage) เท่านั้น
let lng = 'th'
try {
  lng = localStorage.getItem('pawin_lang') === 'en' ? 'en' : 'th'
  document.documentElement.lang = lng
} catch {}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      th: { translation: th },
    },
    lng,
    fallbackLng: 'th',
    interpolation: { escapeValue: false },
  })

export default i18n
